module.exports = __webpack_public_path__ + "static/media/menu8.845021d9.png";